module.exports = __webpack_public_path__ + "static/media/phone-slash.f7de41d2.svg";